import { Form, InputGroup, Button } from "react-bootstrap";
import { BiPlus } from "react-icons/bi";
import OverviewLinkIcon from "./OverviewLinkIcon";
import AutocompleteSelect from "./AutocompleteSelect";

/**
 * Searchable select with optional "New" action to open a create modal.
 * @param {keyof import('./overviewPaths').overviewPath} [overviewLinkEntity] — show open-overview icon when value is set
 */
export default function SelectWithInlineCreate({
  label,
  required,
  className = "mb-2",
  value,
  onChange,
  disabled,
  isInvalid,
  placeholderOption = "",
  hidePlaceholder = false,
  children,
  onAddClick,
  addLabel = "New",
  addDisabled,
  labelClassName,
  overviewLinkEntity,
}) {
  const showLink =
    overviewLinkEntity &&
    value !== undefined &&
    value !== null &&
    String(value).trim() !== "";

  const selectChildren = hidePlaceholder
    ? children
    : (
      <>
        <option value="">{placeholderOption}</option>
        {children}
      </>
    );

  return (
    <Form.Group className={className}>
      {label ? (
        <Form.Label className={labelClassName || "mb-1"}>
          {label}
          {required ? " *" : ""}
        </Form.Label>
      ) : null}
      <InputGroup className="align-items-stretch flex-nowrap">
        <div className="flex-grow-1" style={{ minWidth: 0 }}>
          <AutocompleteSelect
            value={value}
            onChange={onChange}
            disabled={disabled}
            isInvalid={isInvalid}
            required={required}
            placeholder={placeholderOption || "Type to search…"}
          >
            {selectChildren}
          </AutocompleteSelect>
        </div>
        {showLink ? (
          <InputGroup.Text className="px-2 bg-white d-flex align-items-center" style={{ borderLeft: 0 }}>
            <OverviewLinkIcon entity={overviewLinkEntity} id={value} newTab />
          </InputGroup.Text>
        ) : null}
        {onAddClick ? (
          <Button
            variant="outline-secondary"
            type="button"
            onClick={onAddClick}
            disabled={addDisabled || disabled}
            title={addLabel}
          >
            <BiPlus className="me-1" aria-hidden />
            {addLabel}
          </Button>
        ) : null}
      </InputGroup>
    </Form.Group>
  );
}
